export default class Contact {
  static exec() {
    const els = document.querySelectorAll('[data-page="contact"]');
        els.forEach(function (el) {
            new Contact(el);
        });
  }

  constructor(el) {
    let self = this;
    this.el = el;
    this.contactFormLink = el.querySelector('[data-el="contact-form-link"]');
    this.requestFormLink = el.querySelector('[data-el="request-form-link"]');
    this.contactForm = el.querySelector('[data-el="contact-form"]');
    this.requestForm = el.querySelector('[data-el="request-form"]');

    this.contatFormWpcf7 = this.contactForm.querySelector('.wpcf7');
    this.requestFormWpcf7 = this.requestForm.querySelector('.wpcf7');
    this.contactFormLink.addEventListener('click', () => {
      self.contactFormLink.dataset.state = 'active';
      self.requestFormLink.dataset.state = 'inactive';
      self.contactForm.classList.remove('hidden');
      self.requestForm.classList.add('hidden');
    });
    this.requestFormLink.addEventListener('click', () => {
      self.requestFormLink.dataset.state = 'active';
      self.contactFormLink.dataset.state = 'inactive';
      self.contactForm.classList.add('hidden');
      self.requestForm.classList.remove('hidden');
    });

    this.contatFormWpcf7.addEventListener('wpcf7mailsent', (e) => {
      setTimeout(() => {
        window.location.href = '/contact/thanks';
      }, 3000);
    });
    this.requestFormWpcf7.addEventListener('wpcf7mailsent', (e) => {
      setTimeout(() => {
        window.location.href = '/contact/request-thanks';
      }, 3000);
    });
  }
}
